<template>
    <div class="page">
        
       
        <div class="page-content">

            <div class="container">
                <center>
                    <img src="static/images/logo.png" style="width: 200px; margin-top: 10%;"/>
                </center>
                <h2 style="text-align: center;">
                    <i class="las la-file"></i>
                    Acessar prescrição digital
                </h2>
            </div>


            <div class="">
                <form  method="post" v-on:submit.prevent="submit" novalidate="" autocomplete="off">
                    <div class="list" style="margin-top: 16px">
                        <ul class="row">
                            <li class="item-content item-input col-100 mt-10">
                                <div class="item-inner">
                                    <div class="item-title item-label" style="text-align: center;">Token de 5 dígitos:</div>
                                    <div class="item-input-wrap">
                                        <input type="text" maxlength="5" placeholder="Escreva aqui.." v-model="form.senha" style="font-size: 22px; text-align: center;" class="form-control"/>
                                    </div>
                                </div>
                            </li>                                                        
                        </ul>
                    </div>
                    <div class="block">

                        <button type="submit" class="link external button-large button button-fill">
                            <i class="las la-eye"></i>
                            Visualizar
                        </button>
                    </div>
                </form>

            </div>
        </div>
        
    </div>     
</template>

<script>
import Toolbar from './Toolbar'
import Top from './Top'
export default {
    name: 'VisualizarPrescricao',
    components: {
        'Toolbar': Toolbar,
        'Top': Top,
    },          
    data () {
        var self                    = this;
        return {
            form: {
                "cod":              "",
                "tipo":             "visualizar",
                "senha":            "",
            }              
        }
    },
    methods: {
        sair: function() {
            var self = this;
            console.log("sair()");
            // self.$router.push({ 
            //     name:       "Login",
            // }).catch(()=>{});                              
            return false;            
        },      
        submit: function(e) {
            var self            = this;
            console.log("submit", e, self.form, JSON.stringify(self.form));
            e.preventDefault();
            loading.show();
            
            axios.post("api/prescricoes.php", self.form)
            .then(response => {
                console.log("ok", response)
                loading.hide();
                window.___app.dialog.alert(response.data.message, "", function() {
                    location.href = self.$root.config.url + "/" + response.data.result.arquivoAssinado;    
                });

            })
            .catch(error => {
                loading.hide();
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });

        },
        get: function() {
            var self        = this;
            console.log("get()", self.form);
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": self.form
                };

                axios.get("api/prescricoes.php", form)
                .then(response => {
                    
                    console.log("get() response", response);
                    if (!response.data.result) {
                        self.sair();
                    }
                    loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    if (error.response) {
                        if (error.response.status == 404) {
                            self.sair();                              
                        }
                    }                    
                });   
            });   
        }  
    }, 
    created: function() {
        var self = this;
        if (!self.$route.query.c) {
            self.sair();
        }
        self.form.cod              = self.$route.query.c;        
        self.get();      
    },  
    mounted: function() {
       
        loading.hide();
    }   
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
   
   
</style>



// WEBPACK FOOTER //
// src/components/VisualizarPrescricao.vue